// AI client — calls server-side Cloud Functions which dispatch to the
// configured provider (Gemini / OpenAI / Anthropic). No API keys
// touch the browser.

import { getFunctions, httpsCallable } from "firebase/functions";

export interface GeminiMessage {
  role: "user" | "model";
  parts: Array<{ text: string }>;
}

interface ChatTurn { role: "user" | "assistant"; content: string }

function historyToTurns(history: GeminiMessage[]): ChatTurn[] {
  return history.map((m) => ({
    role: m.role === "model" ? "assistant" : "user",
    content: m.parts.map((p) => p.text).join(""),
  }));
}

export async function chatWithGemini(history: GeminiMessage[], userMessage: string): Promise<string> {
  const fn = httpsCallable<{ history: ChatTurn[]; message: string }, { reply: string }>(getFunctions(), "aiChat");
  const res = await fn({ history: historyToTurns(history), message: userMessage });
  return res.data.reply;
}

export async function getAgentSuggestion(ticketContext: string): Promise<string> {
  // Best-effort parse of the legacy ticketContext string into structured fields.
  const titleMatch = /Title:\s*(.+)/i.exec(ticketContext);
  const descMatch = /Description:\s*([\s\S]+?)(?:\n\n|$)/i.exec(ticketContext);
  const fn = httpsCallable<unknown, { draft: string }>(getFunctions(), "aiSuggestReply");
  const res = await fn({
    ticketTitle: titleMatch?.[1]?.trim() ?? ticketContext.slice(0, 200),
    ticketDescription: descMatch?.[1]?.trim() ?? ticketContext,
    recentMessages: [],
  });
  return res.data.draft;
}

export interface PreviewTriageResult {
  category: string;
  priority: string;
  confidence: number;
  reason: string;
  suggestKB?: string;
}

export async function previewTriage(title: string): Promise<PreviewTriageResult> {
  const fn = httpsCallable<{ title: string }, PreviewTriageResult>(getFunctions(), "aiPreviewTriage");
  const res = await fn({ title });
  return res.data;
}
